// Chris 31.10: the colour dots on the product cards (snippets/dr-kort-fakta.liquid). Holding
// the mouse over a dot shows that colour's picture on the card; leaving the dots goes back to
// the picked colour. Tapping or clicking a dot picks the colour: the picture, the card's links,
// the price and the stock line follow it, so the shopper sees each colour without opening the
// product. Quick add hides while another colour is picked (assets/dr-kort.css), since it buys
// the card's own product. The listeners are on the document, since filtering, «Vis flere»
// and «Sist sett» draw new cards.
(function () {
  if (window.drKortFarger) return;
  window.drKortFarger = true;

  function bilder(kort) {
    return kort.querySelectorAll('.card-gallery img');
  }

  function forste(kort) {
    return kort.querySelector('.dr-kort-prikk.is-current') || kort.querySelector('.dr-kort-prikk');
  }

  // The card as the page drew it, kept once so the card's own colour can come back.
  function husk(kort) {
    if (kort.drOriginal) return kort.drOriginal;
    var pris = kort.querySelector('product-price .price');
    var forpris = kort.querySelector('product-price .compare-at-price');
    var lager = kort.querySelector('.product-card__content > .lagerstatus-badge');
    kort.drOriginal = {
      prikk: forste(kort),
      bilder: Array.prototype.map.call(bilder(kort), function (img) {
        return { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      }),
      lenker: Array.prototype.map.call(kort.querySelectorAll('a[href]:not(.dr-kort-prikk)'), function (a) {
        return [a, a.getAttribute('href')];
      }),
      pris: pris ? pris.textContent : null,
      forpris: forpris ? forpris.textContent : null,
      lager: lager
    };
    kort.drValgt = kort.drOriginal.prikk;
    return kort.drOriginal;
  }

  function settBilde(img, srcset) {
    var forsteUrl = srcset.split(',')[0].trim().split(' ')[0];
    img.setAttribute('srcset', srcset);
    img.setAttribute('src', forsteUrl);
  }

  function visBilde(kort, prikk) {
    var original = husk(kort);
    var imgs = bilder(kort);
    var egen = prikk === original.prikk;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (egen || !prikk.dataset.bilde1) {
        if (original.bilder[i]) {
          if (original.bilder[i].srcset) img.setAttribute('srcset', original.bilder[i].srcset);
          img.setAttribute('src', original.bilder[i].src);
        }
      } else {
        // The theme shows the next picture while the mouse is on the photo, so the other
        // slides get the colour's second picture.
        settBilde(img, i === 0 ? prikk.dataset.bilde1 : prikk.dataset.bilde2 || prikk.dataset.bilde1);
      }
    }
  }

  function velg(kort, prikk) {
    var original = husk(kort);
    var egen = prikk === original.prikk;
    kort.drValgt = prikk;
    visBilde(kort, prikk);

    kort.querySelectorAll('.dr-kort-prikk').forEach(function (p) {
      p.classList.toggle('is-current', p === prikk);
    });
    if (egen) kort.removeAttribute('data-dr-farge');
    else kort.setAttribute('data-dr-farge', '');

    original.lenker.forEach(function (par) {
      par[0].setAttribute('href', egen ? par[1] : prikk.getAttribute('href'));
    });

    var pris = kort.querySelector('product-price .price');
    if (pris && original.pris !== null) pris.textContent = egen ? original.pris : prikk.dataset.pris;
    var forpris = kort.querySelector('product-price .compare-at-price');
    if (forpris) {
      var gruppe = forpris.closest('[role="group"]') || forpris;
      var ny = egen ? original.forpris : prikk.dataset.forpris;
      gruppe.hidden = !ny;
      if (ny) forpris.textContent = ny;
    }

    var lager = kort.querySelector('.product-card__content > .lagerstatus-badge');
    var mal = prikk.querySelector('template');
    if (lager) {
      var nyLager = egen ? original.lager : mal && mal.content.firstElementChild && mal.content.firstElementChild.cloneNode(true);
      if (nyLager && nyLager !== lager) lager.replaceWith(nyLager);
    }
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse') return;
    var prikk = event.target.closest && event.target.closest('.dr-kort-prikk');
    var kort = prikk && prikk.closest('product-card');
    if (kort) visBilde(kort, prikk);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse') return;
    var rad = event.target.closest && event.target.closest('.dr-kort-prikker');
    if (!rad || (event.relatedTarget && rad.contains(event.relatedTarget))) return;
    var kort = rad.closest('product-card');
    if (kort && kort.drOriginal) visBilde(kort, kort.drValgt);
  });

  // Capture, so the card's own click handling never sees the dot as a link to follow.
  document.addEventListener(
    'click',
    function (event) {
      var prikk = event.target.closest && event.target.closest('.dr-kort-prikk');
      var kort = prikk && prikk.closest('product-card');
      if (!kort) return;
      event.preventDefault();
      event.stopPropagation();
      velg(kort, prikk);
    },
    true
  );

  // Chris 1.11: the sorting chip on category and search pages says what it sorts by,
  // «Sorter: Utvalgte», as in the fasit. Filtering redraws the row, so it is set again
  // whenever the row is drawn.
  function sorterTekst() {
    document.querySelectorAll('.sorting-filter__horizontal').forEach(function (sortering) {
      var etikett = sortering.querySelector('.facets__summary .facets__label');
      var valgt = sortering.querySelector('input:checked');
      var navn = valgt && valgt.closest('label') ? valgt.closest('label').textContent.trim() : '';
      if (!etikett || !navn || etikett.querySelector('.dr-sortert')) return;
      etikett.textContent = 'Sorter: ';
      var del = document.createElement('span');
      del.className = 'dr-sortert';
      del.textContent = navn;
      etikett.appendChild(del);
    });
  }

  // «80×180 (10)» as «80×180» with «10» in grey to the right, as in the fasit's menus.
  function antall() {
    document.querySelectorAll('.facets__inputs-list .checkbox__label-text:not([data-dr-antall])').forEach(function (t) {
      t.setAttribute('data-dr-antall', '');
      var m = t.textContent.trim().match(/^([\s\S]*?)\s*\((\d+)\)$/);
      if (!m) return;
      t.textContent = '';
      var navn = document.createElement('span');
      navn.textContent = m[1];
      var tall = document.createElement('span');
      tall.className = 'dr-antall';
      tall.textContent = m[2];
      t.append(navn, tall);
    });
  }

  if (document.querySelector('.sorting-filter__horizontal, .facets__inputs-list')) {
    sorterTekst();
    antall();
    new MutationObserver(function () {
      sorterTekst();
      antall();
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
})();

// Chris 4.11: the saving written «6 500,-» in place of «6 500 NOK» on the package's round
// sticker (assets/dr-pakke.css). The amount is Christian's bundle selector's own element,
// which rewrites it on every plus and minus, so it is changed back each time it is written.
(function () {
  function rett(el) {
    var t = el.textContent;
    if (/\s*(NOK|kr)\s*$/i.test(t)) el.textContent = t.replace(/\s*(NOK|kr)\s*$/i, ',-');
  }

  function vakt(el) {
    if (el.dataset.drKomma) return;
    el.dataset.drKomma = '1';
    rett(el);
    new MutationObserver(function () { rett(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function finn() {
    document.querySelectorAll('[data-bundle-primary-saving-value]').forEach(vakt);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', finn);
  else finn();
})();

// Chris 4.11 (meeting with Drømmerom): «Bestselgere» on the home page shows each bed once, in
// its best-selling colour, with the other colours as the dots, instead of the same Montessori
// bed in three colours. The list holds twelve (templates/index.json, product_list_fa6P9H);
// a card whose colour dots match an earlier card's is the same bed and is hidden, and at most
// eight are shown.
(function () {
  var MAKS = 8;

  function rydd(seksjon) {
    var sett = {};
    var vist = 0;
    seksjon.querySelectorAll('product-card').forEach(function (kort) {
      var plass = kort;
      while (plass.parentElement && plass.parentElement.querySelectorAll('product-card').length === 1) {
        plass = plass.parentElement;
      }
      var farger = Array.prototype.map.call(kort.querySelectorAll('.dr-kort-prikk'), function (a) {
        return a.getAttribute('href').split('?')[0];
      }).sort().join(',');
      var lenke = kort.querySelector('a[href*="/products/"]');
      var nokkel = farger || (lenke ? lenke.getAttribute('href').split('?')[0] : '');
      if (sett[nokkel] || vist >= MAKS) {
        plass.style.display = 'none';
        return;
      }
      sett[nokkel] = true;
      vist++;
    });
  }

  document.querySelectorAll('[id$="__product_list_fa6P9H"]').forEach(rydd);
})();

